import { environment } from '../../../../../environments/environment';
import { AppConstants } from '../services/api/app-constants';

// $fuel_card_attachments: [FileUploadInput]
// fuel_card_attachments: $fuel_card_attachments
// fuel_card_attachments

export const createFuelMasterQueries = {
  mutation: `
  mutation createFuelMaster(
    $card_expiry_date: String
    $card_number: String
    $card_provider: String
    $created_date: String
    $status: String
    $updated_date: String
  ) {
    ${AppConstants.create}${environment.dbPrefix}${AppConstants.FuelMasterCard}(input: {
      card_expiry_date: $card_expiry_date
      card_number: $card_number
      card_provider: $card_provider
      created_date: $created_date
      status: $status
      updated_date: $updated_date
    }) {

        id
        card_expiry_date
        card_number
        card_provider
        created_date
        status
        updated_date
    }
  }
`,
};

export const updateFuelMasterQueries = {
  mutation: `
    mutation updateFuelMaster(
      $id: ID!,
      $card_expiry_date: String
      $card_number: String
      $card_provider: String
      $updated_date: String
      $status: String
    ) {
      ${AppConstants.update}${environment.dbPrefix}${AppConstants.FuelMasterCard}(input: {
        id: $id,
        card_expiry_date: $card_expiry_date
        card_number: $card_number
        card_provider: $card_provider
        updated_date: $updated_date
        status: $status
      }) {
        id
        card_expiry_date
        card_number
        card_provider
        updated_date
        status
      }
    }
  `,
};

export const getFuelMasterQueries = {
  query: `
  query listFuelCardMasters ($nextToken: String, $limit: Int){
    ${AppConstants.list}${environment.dbPrefix}${AppConstants.listFuelCardMaster}(nextToken: $nextToken, limit: $limit)
    {
      items {
          id
          card_expiry_date
          card_number
          card_provider
          status
          created_date
          updated_date
        }
      nextToken
    }
  }
  `,
};


export const CreateFuelCardDetail= {
  mutation: `
  mutation createFuelCardDetails(
    $employee_id: String
    $employee_name: String
    $status: String
    $fuel_card_id: String
    $assigned_date: String
    $created_date: String
    $updated_date: String
  ) {
    ${AppConstants.create}${environment.dbPrefix}${AppConstants.FuelMasterCard}(input: {
      employee_id: $employee_id
      employee_name: $employee_name
      status: $status
      fuel_card_id: $fuel_card_id
      assigned_date: $assigned_date
      created_date: $created_date
      updated_date: $updated_date
    }) {
      id
      employee_id
      employee_name
      status
      fuel_card_id
      assigned_date
      created_date
      updated_date
    }
  }
`,
}


export const updateFuelCardDetail= {
  mutation: `
  mutation updateFuelCardDetails(
    $employee_id: String
    $employee_name: String
    $status: String
    $fuel_card_id: String
    $assigned_date: String
    $created_date: String
    $updated_date: String
  ) {
    ${AppConstants.update}${environment.dbPrefix}${AppConstants.FuelMasterCard}(input: {
      employee_id: $employee_id
      employee_name: $employee_name
      status: $status
      fuel_card_id: $fuel_card_id
      assigned_date: $assigned_date
      created_date: $created_date
      updated_date: $updated_date
    }) {
      id
      employee_id
      employee_name
      status
      fuel_card_id
      assigned_date
      created_date
      updated_date
    }
  }
`,
}

export const filterByFuelMasterQueries = {
  query: `
  query filterFuelMaster(
    $status: String

  ) {
    ${AppConstants.list}${environment.dbPrefix}${AppConstants.listFuelCardMaster}(filter:{
      status : { eq : $status}
    }){

        id
        card_expiry_date
        card_number
        card_provider
        created_date
        fuel_card_attachments
        status
        updated_date
    }
  }
`,
};


export const filterByFuelMaster = {
  query: `
  query filterFuelMaster(
    $card_number: String
    $status: String
  ) {
    ${AppConstants.list}${environment.dbPrefix}${AppConstants.listFuelCardMaster}(filter:{
      card_number : { eq : $card_number}
      status : { eq : $status}
    }){
        id
        card_number
        status
    }
  }
`,
};


export const updateFuelMasterStatusQueries = {
  mutation: `
    mutation updateFuelMaster(
      $id: ID!,
      $updated_date: String
      $status: String
    ) {
      ${AppConstants.update}${environment.dbPrefix}${AppConstants.FuelMasterCard}(input: {
        id: $id,
        updated_date: $updated_date
        status: $status
      }) {
        id
        card_expiry_date
        card_number
        card_provider
        updated_date
        status
      }
    }
  `,
};


export const createFuelCreditQueries = {
  mutation: `
  mutation createFuelCardCredit(
    $fuel_card_id: String
    $rn_number: String
    $rnc_user_id: String
    $loading_value: String
    $loading_date: String
    $created_date: String
    $updated_date: String
  ) {
    ${AppConstants.create}${environment.dbPrefix}${AppConstants.FuelCardCredit}(input: {
      fuel_card_id: $fuel_card_id
      rn_number: $rn_number
      rnc_user_id: $rnc_user_id
      loading_value: $loading_value
      loading_date: $loading_date
      created_date: $created_date
      updated_date: $updated_date
    }) {
        id
        created_date
        fuelcard {
           card_number
        }
    }
  }
`,
};

export const getFuelCreditQueries = {
  query: `
  query listFuelCardCredit ($nextToken: String, $limit: Int){
    ${AppConstants.list}${environment.dbPrefix}${AppConstants.FuelCardCredit}(nextToken: $nextToken, limit: $limit)
    {
      items {
          id
          fuel_card_id
          fuelcard {
            id
            card_number
          }
          rn_number
          rnc_user_id
          user {
            id
            name
            user_name
          }
          loading_value
          loading_date
          created_date
          updated_date
        }
      nextToken
    }
  }
  `,
};

export const updateFuelCreditQueries = {
  mutation: `
    mutation updateFuelCardCredit(
      $id: ID!,
      $fuel_card_id: String
      $rn_number: String
      $rnc_user_id: String
      $loading_value: String
      $loading_date: String
      $updated_date: String
    ) {
      ${AppConstants.update}${environment.dbPrefix}${AppConstants.FuelCardCredit}(input: {
        id: $id,
        fuel_card_id: $fuel_card_id
        rn_number: $rn_number
        rnc_user_id: $rnc_user_id
        loading_value: $loading_value
        loading_date: $loading_date
        updated_date: $updated_date
      }) {
        id
        updated_date
      }
    }
  `,
};


